import { render, staticRenderFns } from "./ReportedContents.vue?vue&type=template&id=b6c03ad2&scoped=true"
import script from "./ReportedContents.vue?vue&type=script&lang=js"
export * from "./ReportedContents.vue?vue&type=script&lang=js"
import style0 from "./ReportedContents.vue?vue&type=style&index=0&id=b6c03ad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c03ad2",
  null
  
)

export default component.exports